import type { IconNode } from '../types';

/**
 * @name diagram-flow-horizontal
 * @description Lucide SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNOCAxMmguNWEzLjUgMy41IDAgMDEzLjUgMy41IDMuNSAzLjUgMCAwMDMuNSAzLjVoLjUiIC8+CiAgPHBhdGggZD0iTTguNSAxMkEzLjUgMy41IDAgMDAxMiA4LjUgMy41IDMuNSAwIDAxMTUuNSA1aC41IiAvPgogIDxyZWN0IHg9IjE2IiB5PSIxNiIgd2lkdGg9IjYiIGhlaWdodD0iNiIgcng9IjEiIC8+CiAgPHJlY3QgeD0iMTYiIHk9IjIiIHdpZHRoPSI2IiBoZWlnaHQ9IjYiIHJ4PSIxIiAvPgogIDxyZWN0IHg9IjIiIHk9IjkiIHdpZHRoPSI2IiBoZWlnaHQ9IjYiIHJ4PSIxIiAvPgo8L3N2Zz4K) - https://lucide.dev/icons/diagram-flow-horizontal
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const DiagramFlowHorizontal: IconNode = [
  ['path', { d: 'M8 12h.5a3.5 3.5 0 013.5 3.5 3.5 3.5 0 003.5 3.5h.5' }],
  ['path', { d: 'M8.5 12A3.5 3.5 0 0012 8.5 3.5 3.5 0 0115.5 5h.5' }],
  ['rect', { x: '16', y: '16', width: '6', height: '6', rx: '1' }],
  ['rect', { x: '16', y: '2', width: '6', height: '6', rx: '1' }],
  ['rect', { x: '2', y: '9', width: '6', height: '6', rx: '1' }],
];

export default DiagramFlowHorizontal;
